import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {finalize} from "rxjs/operators";
import {HttpActivityService} from "../services/http-activity.service";

@Injectable()
export class ActiveRequestInterceptor implements HttpInterceptor {
  private readonly excludedUrls = [
    "/api/extendSession"
  ];

  constructor(
    private httpActivityService: HttpActivityService
  ) {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldTrack = !this.excludedUrls.some(url =>
      req.url.includes(url)
    );

    if (shouldTrack) {
      this.httpActivityService.increment();
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (shouldTrack) {
          this.httpActivityService.decrement();
        }
      })
    );
  }
}
